// eslint-disable-next-line @typescript-eslint/no-unused-vars
function setFloatingButtonsBottomOffset() {
  const footerBottom = document.querySelector('.footer__bottom');

  if (!footerBottom) return;

  const footerBottomBoundingRect = footerBottom.getBoundingClientRect();
  const rootEl = document.documentElement;
  const marginFromFooter = 5; // we need to keep margin to the footer_bottom

  if (window.innerHeight >= footerBottomBoundingRect.top + window.theme.floatingButtonsOffset - marginFromFooter) {
    const bottomOffset = window.innerHeight - footerBottomBoundingRect.top + marginFromFooter;
    const iframeChatButtonBottomOffset = bottomOffset - 20;

    rootEl.style.setProperty('--floating-buttons-offset', `${bottomOffset}px`);
    rootEl.style.setProperty('--floating-iframe-chat-button-offset', `${iframeChatButtonBottomOffset}px`);
  } else {
    rootEl.style.setProperty('--floating-buttons-offset', `${window.theme.floatingButtonsOffset}px`);
    rootEl.style.setProperty('--floating-iframe-chat-button-offset', `0px`);
  }
}

window.addEventListener('scroll', setFloatingButtonsBottomOffset);
document.addEventListener('DOMContentLoaded', setFloatingButtonsBottomOffset); // add initial value, even if user has not scrolled yet.
